import { Injectable } from '@angular/core';
import { DialogService } from '@sc/feature-dialog';
import { PicturesViewerComponent } from '../../components/pictures-viewer/pictures-viewer.component';
import { PicturesViewerData } from '@sc/data-access-models';

@Injectable({
  providedIn: 'root',
})
export class PicturesViewerService {
  constructor(public dialogService: DialogService) {}

  show(data: PicturesViewerData): void {
    this.dialogService
      .showDialog(
        PicturesViewerComponent,
        data,
        'dialog-close-btn-outside-container'
      )
      .subscribe(() => {});
  }
}
